var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMagnify = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 14682"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  "data-name": "Rectangle 6401"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 14661",
  transform: "translate(-1320.268 -255.663)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 7.786,
  cy: 7.786,
  r: 7.786,
  "data-name": "Ellipse 1550",
  transform: "translate(1323.416 258.483)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m1336.344 272.114 4.775 4.729",
  "data-name": "Line 1223"
})))));
export { SvgMagnify as ReactComponent };
export default __webpack_public_path__ + "static/media/magnify.d187dab5fb2f27b524075a34f52d9d4b.svg";